import {AfterViewInit, Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

import {LayoutMgrService} from "../../services/layout-mgr/layout-mgr.service";
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {CordovaService} from '../../services/cordova/cordova.service';
import {NaverLoginService} from "../../services/naver-login/naver-login.service";

@Component({
  selector: 'app-naver-login-popup',
  template: `
      <article class="naver popup">
          <div class="popup-wrapper">
              <article class="popup-msg-form">
                  <div class="head-box">책갈피와 네이버 아이디 연동</div>
                  <div class="body-box">아래 네이버 버튼을 누르면 네이버 로그인 창이 뜹니다.<br/><br/>한국어 베풂은 개인 정보를 수집하지 않습니다.</div>
              </article>

              <div class="popup-foot-box">
                  <div id="naver_id_login" class="popup-foot-btn naver-login"></div>
                  <a class="popup-foot-btn type-3"
                     (click)="onClickCancelBtn($event)">취소</a>
              </div>
          </div>
      </article>
  `,
})
export class NaverLoginPopupComponent implements OnInit, AfterViewInit {

  constructor(
    private router: Router,
    private lm: LayoutMgrService,
    private cordovaSvc: CordovaService,
    private naverLoginSvc: NaverLoginService,
    private globalEventSvc: GlobalEventService
  ) {
  }

  ngOnInit(): void {
    this.naverLoginSvc.MakeLoginBtn();
    // this.initNaverLogin();
    // window.addEventListener('message', this.receiveMessage.bind(this), false);
  }

  ngAfterViewInit(): void {
    this.naverLoginSvc.CustomizeNaverBtn();
  }


/*
  private initNaverLogin() {
    const naverLoginInstance = new naver_id_login(this.cordovaSvc.NAVER_CLIENT_ID, this.cordovaSvc.NAVER_CALLBACK_URL);
    const state = naverLoginInstance.getUniqState();
    naverLoginInstance.setButton("green", 2,50);
    naverLoginInstance.setState(state); // 넣기는 하지만 사용하지 않음.
    // naverLoginInstance.setDomain(environment.host); // same subdomain으로 필요하지 않음.
    // naverLoginInstance.setPopup(); // 설졍하면 팝업창이 열리면서 로그인 한다.
    naverLoginInstance.init_naver_id_login();
  }
 */

  /*
  receiveMessage(event: MessageEvent) {
    // 원하는 도메인에서 보낸 메시지만 처리하도록 설정 (옵션)
    // if (event.origin !== "http://your-expected-origin.com")
    //   return;

    console.log("Received message:", event.data);
    // 여기서 Angular 로직을 실행하거나 서비스에 데이터를 저장

    this.lm.naverLoginPopup$?.next(event.data);
    this.lm.naverLoginPopup$?.complete();
  }
  */

  onClickCancelBtn(event: MouseEvent): void {
    console.log("cancel!!!");

    event.preventDefault();
    event.stopPropagation();
    this.globalEventSvc.Click(event);

    if (!this.lm.naverLoginPopup$) {
      throw new Error('NaverLoginPopupComponent.onClickBtn: this.lm.msgPopup$ is undefined');
    }

    this.lm.naverLoginPopup$.next(null);
    this.lm.naverLoginPopup$.complete();
  }
}
